
const VISA = 'VISA';
const MASTERCARD = 'MASTERCARD';
const TELERED = 'TELERED';
const CLAVE = 'CLAVE';

function getBrand(pan) {
    if (pan && typeof pan === 'string' ) {
        if (pan.startsWith('4')) {
            return VISA;
        } else if (pan.startsWith('5') || pan.startsWith('2')) {
            return MASTERCARD
        }
    }

    return null;
}

function lunh(value) {
    if (value) {
        if (value.length === 16) {
            // remove all non digit characters
            value = value.replace(/\D/g, '');
            
            if(!value){
                return false;
            }
            
            let sum = 0;
            let shouldDouble = false;
            // loop through values starting at the rightmost side
            for (let i = value.length - 1; i >= 0; i--) {
                let digit = parseInt(value.charAt(i));

                if (shouldDouble) {
                    if ((digit *= 2) > 9) digit -= 9;
                }

                sum += digit;
                shouldDouble = !shouldDouble;
            }

            return (sum % 10) === 0;
        }

    }

    return false;

}

export  {
    VISA, MASTERCARD, TELERED, CLAVE,
    getBrand, lunh
}
